<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Photo } from '@procommerce/picture';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String },
    header_type: { type: String },
    content: { type: String },
    photos: { type: Array as PropType<Photo[]>, required: true },
  });
</script>
<template>
  <section class="mosaic">
    <header class="mosaic__header">
      <SfHeading v-if="header" large class="mosaic__header" :type="header_type || 'h2'" v-html="header" />
      <div v-if="content" class="mosaic__content section-typography" v-html="content" />
    </header>
    <div class="mosaic__images">
      <MediaPicture photoable="Section" type="mosaic" :photo="photos" />
    </div>
  </section>
</template>
<style lang="scss">
  @use "$assets/mixins/media";

  :root {
    --sf-mosaic-gap: 2rem;
    --sf-mosaic-header-gap: 1rem;
    --sf-mosaic-padding: 0;
    --sf-mosaic-images-gap: 2rem;

    @include media.query(lg) {
      --sf-mosaic-gap: 1rem;
      --sf-mosaic-header-gap: 0.5rem;
      --sf-mosaic-padding: 0 1rem;
      --sf-mosaic-images-gap: 1rem;
    }
  }

  .mosaic {
    display: flex;
    flex-direction: column;
    gap: var(--sf-mosaic-gap);
    padding: var(--sf-mosaic-padding);

    &__header {
      display: flex;
      flex-direction: column;
      gap: var(--sf-mosaic-header-gap);
    }

    &__images {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--sf-mosaic-images-gap);

      img {
        aspect-ratio: 4 / 3;
        max-width: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
</style>
